import { RouteAccessFallbackVariant } from './RouteAccessFallback.types';

export const ERROR_FALLBACK_COPIES: Record<
  RouteAccessFallbackVariant,
  { title: string; subtitle: string; buttonLabel: string }
> = {
  default: {
    title: 'Ups, algo salió mal',
    subtitle: 'Ha ocurrido un error. Por favor, inténtalo de nuevo.',
    buttonLabel: 'Reintentar',
  },
  'page-not-found': {
    title: 'Página no encontrada',
    subtitle: 'Lo sentimos, la página que buscas no existe.',
    buttonLabel: 'Ir al inicio',
  },
  unauthorized: {
    title: 'Acceso restringido',
    subtitle: 'No tienes permiso para acceder a esta sección.',
    buttonLabel: 'Volver al inicio',
  },
};
